import NotificationAPI from '@/apis/other/notificationAPI';
export default {
  namespaced: true,

  state: {
    newNotify: null,
    amountNotifyUnread: 0,
    totalNotifies: 0,

    /**
     * Có phải là đc mở từ thông báo bình luận hay ko
     */
    isOpenFromCommentNotify: false,

    /**
     * Trạng thái Active của toast msg thông báo
     */
    isActiveToastMsgNotify: false,

    /**
     * Hành động của thông báo
     */
    action: null,

    /**
     * ID của công việc cần mở form
     */
     taskID: null,

     /**
     * Biến dùng để nhận biết hành động mở form công việc
     */
    toggleTaskForm: false,

  },

  getters: {
    
  },

  mutations: {
    setNewNotify(state,data){
      state.newNotify = data
    },

    setAmountNotifyUnread(state,data){
      state.amountNotifyUnread = data
    },

    setTotalNotifies(state,data){
      state.totalNotifies = data
    },
    
    setIsOpenFromCommentNotify(state,data){
      state.isOpenFromCommentNotify = data
    },

    /**
     * Đóng mở toast msg thông báo
     * @param {*} state state object
     * @param {boolean} notifyState Trạng thái đóng mở của toast msg thông báo (true: mở, false: đóng)
     */
    toggleToastMsgNotify(state, notifyState) {
      state.isActiveToastMsgNotify = notifyState;
    },

    /**
     * Mở form công việc
     * @param {*} state state object
     * @param {string} processExecutionID ID của kiến nghị cần mở
     * @author: BMThang(13/05/2022)
     */
     openTaskForm(state, { taskID, action }) {
      state.toggleTaskForm = !state.toggleTaskForm;
      state.action = action;
      state.taskID = taskID;
    },

  },

  actions: {
    /**
     * Lấy số lượng thông báo chưa đọc
     * @param {object} param tham số
     */
    async fetchUnreadNotificationsCount({ commit }, param) {
      try {
        const unreadNotifyParam = {...param, isView: false}
        const res = await NotificationAPI.getTotalNotificationCount(unreadNotifyParam)
        if (res) {
          commit('setAmountNotifyUnread', res)
        } else {
          commit('setAmountNotifyUnread', 0)
        }
      } catch (error) {
        console.log(error.message)
        commit('setAmountNotifyUnread', 0)
      }
    },

    setNewNotify({commit},data){
      commit("setNewNotify",null);
      setTimeout(() => {
        commit("setNewNotify",data)
      },10)
    },

    setAmountNotifyUnread({commit},data){
      commit("setAmountNotifyUnread",data);
    },

    setTotalNotifies({commit},data){
      commit("setTotalNotifies",data);
    },

    increaseAmountNotifyUnread({commit,state}){
      commit("setAmountNotifyUnread",state.amountNotifyUnread + 1);
    },
    
    decreaseAmountNotifyUnread({commit,state}){
      commit("setAmountNotifyUnread",state.amountNotifyUnread - 1);
    },

    toggleToastMsgNotify({commit},data){
      commit("toggleToastMsgNotify", data);
    },
    
  }
}
